import { Switch, useRouteMatch } from 'react-router-dom';
import { Contact } from 'assets/js/pages/contacts/Contact';
import { ContactCustomFields } from 'assets/js/pages/contacts/ContactCustomFields';
import { ContactTagMergeFormModal } from 'assets/js/pages/contacts/ContactTagMergeFormModal';
import { ContactTags } from 'assets/js/pages/contacts/ContactTags';
import { Contacts } from 'assets/js/pages/contacts/Contacts';
import { ConvertContactFormDrawer } from 'assets/js/pages/contacts/ConvertContactFormDrawer';
import { CreateContactFormDrawer } from 'assets/js/pages/contacts/CreateContactFormDrawer';
import { UpdateContactNotificationsModal } from 'assets/js/pages/contacts/UpdateContactNotificationsModal';
import { UpdateTagsModal } from 'assets/js/pages/contacts/UpdateTagsModal';
import { CustomFieldFormDialog } from 'components/custom-fields/CustomFieldFormDialog';
import { DialogRoute } from 'components/dialog-route';
import { DrawerRoute } from 'components/drawer-route';
import { Route } from 'components/router/Route';

const ContactsRouter = () => {
    const match = useRouteMatch();

    return (
        <Switch>
            <Route path={`${match.path}/:contact_id(\\d+)`} component={Contact} />
            <Route path={match.path} component={ContactsIndexRouter} />
        </Switch>
    );
};

const ContactsIndexRouter = () => {
    const match = useRouteMatch();

    return (
        <>
            <DrawerRoute path={`${match.path}/new`} component={CreateContactFormDrawer} />
            <DrawerRoute
                path={`${match.path}/convert/:contact_id(\\d+)`}
                component={ConvertContactFormDrawer}
            />
            <Switch>
                <Route path={`${match.path}/tags`} component={ContactTagsRouter} />
                <Route path={`${match.path}/custom-fields`} component={ContactCustomFieldsRouter} />
                <Route path={match.path} component={Contacts} />
            </Switch>
            <DialogRoute path={`${match.path}/update-tags`} component={UpdateTagsModal} />
            <DialogRoute
                path={`${match.path}/update-notifications`}
                component={UpdateContactNotificationsModal}
            />
        </>
    );
};

const ContactTagsRouter = () => {
    const match = useRouteMatch();

    return (
        <>
            <DialogRoute
                path={`${match.path}/:tag_id/merge`}
                component={ContactTagMergeFormModal}
            />
            <Switch>
                <Route path={match.path} component={ContactTags} />
            </Switch>
        </>
    );
};

const ContactCustomFieldsRouter = () => {
    const match = useRouteMatch();

    return (
        <>
            <DialogRoute
                path={[`${match.path}/new`, `${match.path}/:custom_field_id/edit`]}
                component={CustomFieldFormDialog}
                contentProps={{
                    className: 'max-w-2xl',
                }}
            />
            <Switch>
                <Route path={match.path} component={ContactCustomFields} />
            </Switch>
        </>
    );
};

export { ContactsRouter, ContactCustomFieldsRouter, ContactTagsRouter };
